import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaTasks } from "react-icons/fa";
import InfoTip from "../../components/InfoTip";
import { ErrorBox } from "./components/common";
import ProjectList from "./components/ProjectList";
import ClientSearch from "./components/ClientSearch";
import { errorMessage, staffDmApi } from "./dmApi";
import "./dm.css";
import "../../assets/css/PageHeading.css";

/**
 * Digital Marketing landing page. Staff search / list DM-enrolled clients and open a client's
 * details page; portal users (api=portalDmApi) go straight to their own company's projects.
 */
function DMProjects({ api = staffDmApi, basePath = "/dm-projects" }) {
  const navigate = useNavigate();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (api.isStaff) return;
    api.meta().then(setMeta).catch((err) => setError(errorMessage(err, "Could not load options")));
  }, [api]);

  return (
    <div className="dmp">
      {api.isStaff ? (
        <>
          <div className="co-page-head">
            <div className="dmp-head-title">
              <h2 className="co-page-head__title">Marketing Profiles</h2>
              <InfoTip label="Client not listed?">
                <strong>Client not listed?</strong> Digital Marketing is assigned from the client’s edit page (
                <Link to="/tenants">Clients</Link> → Edit → services).
              </InfoTip>
            </div>
          </div>
          <div className="dmp-card dmp-card--clients">
            <ClientSearch
              api={api}
              onSelect={(t) => navigate(`${basePath}/client/${t.tenant_id}`)}
              onViewProjects={(t) => navigate(`${basePath}/client/${t.tenant_id}?tab=dm-projects`)}
              actions={
                <Link to="/dm-setup-template" className="dmp-btn dmp-btn--ghost">
                  <FaTasks aria-hidden="true" /> Setup Template
                </Link>
              }
            />
          </div>
        </>
      ) : (
        <>
          <div className="cportal-page-head">
            <h1>Marketing Projects</h1>
          </div>
          <ErrorBox message={error} />
          <ProjectList api={api} meta={meta} basePath={basePath} title="Projects" />
        </>
      )}
    </div>
  );
}

export default DMProjects;
